import React from 'react';
import { PopoverActions } from '@mui/material/Popover';
import { Paper } from '@mui/material';
import { CalendarEventPopoverActionsContext } from './calendar-event-popover-actions-context';
import { AnimatedPopover, AnimatedPopoverProps } from './animated-popover';


export type CalendarEventPopoverProps = AnimatedPopoverProps & {

};


export const CalendarEventPopover: React.FC<CalendarEventPopoverProps> = ({ children, ...props }) => {
  const popoverActionsRef = React.useRef<PopoverActions>({
    updatePosition: () => {
      window.dispatchEvent(new Event('scroll'));
    },
  });

  return (
    <CalendarEventPopoverActionsContext.Provider value={popoverActionsRef}>
      <AnimatedPopover {...props}>
        <Paper elevation={20}>
          {children}
        </Paper>
      </AnimatedPopover>
    </CalendarEventPopoverActionsContext.Provider>
  );
};
